import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { sentryDsn, sentryEnv } from 'src/constants/sentryConfig';

export const sentryInitializer = () => {
  if (!sentryDsn) {
    console.warn('Cannot found Sentry DSN. Aborting it initialization');
    return;
  }
  try {
    Sentry.init({
      dsn: sentryDsn,
      integrations: [new BrowserTracing()],
      environment: sentryEnv || 'dev',
      tracesSampleRate: 0,
    });
  } catch (error) {
    console.warn('Error on initialize Sentry >>', error);
  }
};
